import { memo } from "react";
import { TiTick } from "react-icons/ti";

const Stepper = ({ 
  steps, currentStep, setCurrentStep, complete, onCompleted, disabledNext, draftOptions, children 
} : {
  children?: JSX.Element,
  steps: string[],
  currentStep: number,
  onCompleted: () => void,
  setCurrentStep: (step: number) => void,
  complete: boolean,
  disabledNext?: boolean
  draftOptions?: {
    isDraft?: boolean
    draftStep?: number
    onClickDraft?: () => void
  }
}) => {
  const { isDraft , draftStep, onClickDraft } = draftOptions!
  return (
    <>
      <div className="flex justify-around py-3">
        {steps?.map((step, i) => (
          <div
            key={i}
            className={`step-item ${currentStep === i + 1 && "active"} ${
              (i + 1 < currentStep || complete) && "complete"
            } `}
          >
            <div className="step">
              {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
            </div>
            <p className="text-gray-500">{step}</p>
          </div>
        ))}
      </div>
      <div className="py-3">
        {children}
      </div>
      {!complete && currentStep !== 1 && <div className="flex justify-between pt-3">
        <button
          className="btn-outline-secondary"
          disabled={currentStep === 1}
          onClick={() => setCurrentStep(currentStep - 1)}
        >
          กลับ
        </button>
        <div className="space-x-3 ">
          {isDraft && draftStep === currentStep && <button className="w-36 btn-outline-primary" onClick={onClickDraft}>
            บันทึกไว้ก่อน
          </button>}
          <button
            className={` w-36${currentStep === steps.length ? " btn-success" : " btn-primary"}`}
            onClick={() => {
              currentStep === steps.length
                ? onCompleted()
                : setCurrentStep(currentStep + 1);
            }}
            disabled={disabledNext}
          >
            {currentStep === steps.length ? "ยืนยันส่งงาน" : "ส่งงาน"}
          </button>
        </div>
      </div>}
    </>
  );
};

export default memo(Stepper);